export default __webpack_public_path__ + "media/color/grc-6c5cb432.svg";